import React from 'react';
import { useQueryContext } from '../utils/QueryContext';

// Sits in the top bar's empty right side, left of the theme toggle, so it never covers the search.
const GlobalLoadingIndicator = () => {
  const { isLoading, slowQueryWarning } = useQueryContext();

  // Show immediately for any loading, but only for non-pagination queries
  // (pagination queries are marked and don't trigger global loading)
  if (!isLoading && !slowQueryWarning) {
    return null;
  }

  return (
    <div
      role="status"
      className="loading-toast fixed top-[10px] right-16 z-[3400] pointer-events-none flex items-center gap-2 h-7 px-2.5 rounded-control border border-rule bg-sheet text-small text-graphite whitespace-nowrap"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${slowQueryWarning ? 'bg-med' : 'bg-signal'}`} aria-hidden="true" />
      {slowQueryWarning ? 'Taking longer than expected...' : 'Loading data...'}
    </div>
  );
};

export default GlobalLoadingIndicator;
